import {
    useCallback,
} from 'react'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import {
    useGetRequestSpreadSheetAdapter,
} from 'app/shared-components/SkyNetSpreadSheet'
import useSimpleApiRequest from 'app/hooks/useSimpleApiRequest'
import StatusHandler from 'app/shared-components/StatusHandler'
import {
    AsyncMutationOptions,
} from 'app/types/request.types'
import {
    useSkyNetPagination,
    SkyNetPaginationContext,
} from 'app/shared-components/SkyNetPagination'
import requests from 'app/requests/RateCard/RateCard.requests'
import {
    RegionalServiceAvailabilityEditable,
    RegionalServiceAvailabilityItem,
} from '../RegionalServiceAvailability.types'
import RegionalServiceAvailabilitySpreadsheet from '../RegionalServiceAvailabilitySpreadsheet'
import {
    prepareRegionalServiceAvailabilityToBulkEdit,
} from '../RegionalServiceAvailability.utils'
import defaultRateCardsBulkSort from '../../RateCardsBulkEdit/RateCardsBulkEdit.utils'

export default function RegionalServiceAvailabilityBulkEdit({
    onClose,
}: Readonly<{
    onClose: () => void;
}>) {
    const paginationOptions = useSkyNetPagination(100)
    const {
        isError, loaded, error, data, refetch,
    } = useGetRequestSpreadSheetAdapter<RegionalServiceAvailabilityItem>({
        config: requests.regionalServiceAvailabilityFilterRequest,
        requestKey: RequestKeys.regionalServiceAvailabilityFilterRequest,
        enabled: true,
        paginationOptions,
        defaultSort: defaultRateCardsBulkSort,
    })

    const {
        mutateAsync: bulkEdit,
    } = useSimpleApiRequest<{ items: RegionalServiceAvailabilityEditable[] }>({
        name: 'RegionalServiceAvailabilityBulkUpdate',
        title: 'Regional Service Availability were updated',
        requestParams: requests.regionalServiceAvailabilityBulkEdit(),
        onSuccess: refetch,
    })

    const onSave = useCallback(
        async (
            items: RegionalServiceAvailabilityItem[],
            options?: AsyncMutationOptions,
        ) => {
            await bulkEdit({
                items: prepareRegionalServiceAvailabilityToBulkEdit(items),
            }, {
                ...options,
                onSuccess: options?.onSuccess || onClose,
            })
        },
        [
            bulkEdit,
            onClose,
        ],
    )

    return (
        <StatusHandler
            isError={isError}
            isFetching={!loaded}
            error={error}
            isSuccess={loaded}
        >
            <SkyNetPaginationContext.Provider value={paginationOptions}>
                <RegionalServiceAvailabilitySpreadsheet
                    data={data}
                    onCancel={onClose}
                    onSave={onSave}
                />
            </SkyNetPaginationContext.Provider>
        </StatusHandler>
    )
}
